/*
 * @Description: 岗位说明书关联
 * @Author: 杨志航
 * @Date: 2026-02-11 14:57:51
 */
import React, { useState, useEffect } from 'react'
import api from 'api'
import {
  Table,
  Form,
  Drawer,
  Button,
  Select,
  Alert,
  Popconfirm,
  message,
} from 'antd'
import { allTrim, filterParams } from '@/utils'
import EditRelation from './EditRelation'

const { Column } = Table
const FormItem = Form.Item
const Option = Select.Option

let pageSize = 10
let currentPage = 1
let searchParams = {
  limit: pageSize, 
  page: currentPage
}

const Relation = props => {
  const { getFieldDecorator, validateFields, resetFields, setFieldsValue, getFieldsValue } = props.form
  const [count, setCount] = useState(0)
  const [list, setList] = useState([])
  const [loading, setLoading] = useState(false)
  const [editVisible, setEditVisible] = useState(false)
  const [editData, setEditData] = useState({})
  const [groupList, setGroupList] = useState([])
  const [departmentList, setDepartmentList] = useState([])
  const [jobPostList, setJobPostList] = useState([])
  const [jobPostFileList, setJobPostFileList] = useState([])

  useEffect(() => {
    getSearchData()
    resetParams()
    getList()
  }, [])

  const resetParams = () => {
    searchParams = {
      limit: pageSize, 
      page: currentPage
    }
  }

  const formItemLayout = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 6 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 18 },
    }
  }

  //获取列表
  const getList = () => {
    setLoading(true)
    api.getJobPostFileList(searchParams).then(res => {
      const { list, count } = res
      setList(list)
      setCount(count)
      setLoading(false)
    }).catch(() => { setLoading(false) })
  }

  //重置
  const onReset = () => {
    setDepartmentList([])
    resetFields()
    currentPage = 1
    resetParams()
    getList()
  }
  //提交
  const formSubmit = evt => {
    evt.preventDefault()
    currentPage = 1
    resetParams()
    setFieldsValue(allTrim(getFieldsValue()))
    validateFields((err, vals) => {
      if (!err) {
        vals = filterParams(vals)
        searchParams = {...searchParams, ...vals}
        getList()
      }
    })
  }
  //点击分页
  const onChangeTable = (pagination, filters, sorter) => {
    searchParams.page = currentPage = pagination.current
    searchParams.limit = pageSize = pagination.pageSize
    getList()
  }

  // 编辑
  const handleEdit = data => {
    setEditData(data)
    setEditVisible(true)
  }

  const getSearchData = () => {
    Promise.all([
      api.getSelectGroupList({ limit: global.paramsLimit }),
      api.getJobPostList({ limit: global.paramsLimit }),
      api.getJobPostFileList({ limit: global.paramsLimit }),
    ]).then(list => {
      setGroupList(list[0].list)
      setJobPostList(list[1].list)
      setJobPostFileList(list[2].list)
    })
  }

  const getDepartMentList = (groupId, departmentName) => {
    api.getStaffJobPostDepartmentList({ 
      groupId,
    }).then(res => {
      setDepartmentList(res)
      setFieldsValue({
        departmentName,
      })
    }).catch(err => console.log(err))
  }

  const onSelectGroup = groupId => {
    if (groupId) {
      getDepartMentList(groupId, undefined)
    } else {
      setDepartmentList([])
      setFieldsValue({
        departmentName: undefined,
      })
    }
  }

  const handleDel = id => {
    setLoading(true)
    api.delStaffJobPostFile({
      id
    }).then(() => {
      message.success('删除成功')
      getList()
    }).catch(() => { setLoading(false) })
  }

  return <>
    <div className="search-doc-wrap">
      <Form onSubmit={formSubmit} {...formItemLayout}>
        <div className="form-box">
          <FormItem label="所属事业群">
            {getFieldDecorator('groupId')(<Select 
              placeholder="请选择"
              showSearch
              allowClear
              optionFilterProp="children"
              onChange={onSelectGroup}
            >
              {
                groupList.map((item, index) => <Option key={index} value={item.id}>{item.name}</Option>)
              }
            </Select>)}
          </FormItem>
          <FormItem label="所属部门">
            {getFieldDecorator('departmentName')(<Select 
              placeholder="请选择"
              showSearch
              allowClear
              optionFilterProp="children"
            >
              {
                departmentList.map((item, index) => <Option key={index} value={item}>{item}</Option>)
              }
            </Select>)}
          </FormItem>
          <FormItem label="岗位说明书">
            {getFieldDecorator('jobPostFileId')(<Select 
              placeholder="请选择"
              showSearch
              allowClear
              optionFilterProp="children"
            >
              {
                jobPostFileList.map((item, index) => <Option key={index} value={item.id}>{item.fileName}</Option>)
              }
            </Select>)}
          </FormItem>
          <FormItem label="岗位名称">
            {getFieldDecorator('jobPostId')(<Select 
              placeholder="请选择"
              showSearch
              allowClear
              optionFilterProp="children"
            >
              {
                jobPostList.map((item, index) => <Option key={index} value={item.id}>{item.name}</Option>)
              }
            </Select>)}
          </FormItem>
        </div>
        <FormItem className="btns" label=" " colon={false}>
          <Button type="primary" htmlType="submit">查询</Button>
          <Button onClick={onReset}>重置</Button>
        </FormItem>
      </Form>
    </div>
    <div className="line"></div>
    <div>
      <Alert className="corp-count" message={`总计：${count}条数据`} type="info" showIcon />
      <Table
        size="small"
        dataSource={list}
        rowKey="id"  
        loading={loading}
        pagination={{
          pageSize,
          total: count,
          current: currentPage,
          showQuickJumper: true,
          showSizeChanger: true,
          pageSizeOptions: ['10', '50', '100', '500', '1000', '2000']
        }}
        onChange={onChangeTable}
      >
        <Column 
          title="岗位说明书" 
          dataIndex="fileName"
          render={(text, record) => <a href={record.fileInfo.url} target='_blank'>{text}</a>} 
        />
        <Column 
          title="关联关系" 
          dataIndex="postsTxt" 
          render={(text, record) => (
            <>
              {text && text.map((item, index) => <div key={index}>{item}</div>)}
            </>
          )} 
        />
        <Column title="编辑人" dataIndex="staffName" />
        <Column title="编辑时间" dataIndex="updateTime" />
        <Column 
          title="操作"
          key="set" 
          align="center"
          width={100}
          render={(text, record) => (
            <>
              {record.postsTxt?.length > 0 && (
                <a onClick={() => handleEdit(record)}>编辑</a>
              )}
              <Popconfirm 
                title="请确认是否删除?" 
                onConfirm={() => handleDel(record.id)}
              >
                <a style={{ marginLeft: '10px' }}>删除</a>
              </Popconfirm>
            </>
          )}
        />
      </Table>
    </div>
    <Drawer
      title="编辑"
      width={600}
      onClose={() => setEditVisible(false)}
      visible={editVisible}
      destroyOnClose={true}
    >
      <EditRelation 
        setEditVisible={setEditVisible}
        getList={getList}
        editData={editData}
      />
    </Drawer>
  </>
}

export default Form.create()(Relation)
